import { RSAA } from 'redux-api-middleware'
import { getApiPath, makeQueryParams } from 'sidecar-utility-library'

import { initialState, types } from './index'

export const fetchDoctorDetail = ({
  npi,
  excludeSyntheticNpis,
  includeSpecialtiesAtLocation,
}) => ({
  [RSAA]: {
    endpoint: getApiPath(
      `doc`,
      `doctors/${npi}${makeQueryParams({ excludeSyntheticNpis, includeSpecialtiesAtLocation })}`,
      'v2',
    ),
    method: 'GET',
    types: [
      types.FETCH_DOCTOR_DETAIL_REQUEST,
      types.FETCH_DOCTOR_DETAIL_SUCCESS,
      types.FETCH_DOCTOR_DETAIL_ERROR,
    ],
  },
})

export const clearDoctorDetail = () => ({
  type: types.CLEAR_DOCTOR_DETAIL,
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.CLEAR_DOCTOR_DETAIL: {
      return {
        ...state,
        doctorDetails: {
          ...state.doctorDetails,
          details: initialState.doctorDetails.details,
        },
      }
    }
    case types.FETCH_DOCTOR_DETAIL_REQUEST: {
      return {
        ...state,
        doctorDetails: {
          ...state.doctorDetails,
          busy: true,
          error: '',
        },
      }
    }
    case types.FETCH_DOCTOR_DETAIL_SUCCESS: {
      return {
        ...state,
        doctorDetails: {
          ...state.doctorDetails,
          busy: false,
          details: payload,
        },
      }
    }
    case types.FETCH_DOCTOR_DETAIL_ERROR: {
      return {
        ...state,
        doctorDetails: {
          ...state.doctorDetails,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    // ----------

    default:
      return state
  }
}
